export default "__VITE_ASSET__DK9h6eQ$__"